import { Component } from "react";

export default class ErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-dvh items-center justify-center bg-ink p-8 text-center font-sans text-slate-200">
                    <div>
                        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-celestial-gold">
                            Something broke
                        </p>
                        <p className="text-lg">
                            The cosmos hiccuped. Reload the page to try again.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
